/**
 * Clear all persisted list-state entries from sessionStorage.
 *
 * Used on logout so the next login starts with clean filters, search and
 * pagination on every list page (Sessions, Venues, Incidents, Attendance,
 * Unpaid Attendance, etc.).
 */
export function clearPersistedListState() {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("list-state:")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    // ignore storage access errors
  }
}
